import React from "react";
import { Link } from "react-router-dom";

const Terms = () => {
  return (
    <div className="about-area-1 space">
      <div className="about1-shape-img shape-mockup">
        <img
          className="about1-shape-img-1 spin"
          src="assets/img/normal/about_shape1-2.svg"
          alt="LealChapayPintura.com"
        />
        <img
          className="about1-shape-img-2 spin2"
          src="assets/img/normal/about_shape1-1.svg"
          alt="LealChapayPintura.com"
        />
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-between flex-row-reverse">
          <div className="col-xxl-12">
            <div className="about-content-wrap">
              <div className="title-area me-xl-50 mb-30">
                <span className="sub-title">Aviso Legal - Términos y condiciones</span>
                <div className="sec-text">
                  <p>
                    En cumplimiento con el deber de información recogido en
                    artículo 10 de la Ley 34/2002, de 11 de Julio, de Servicios de
                    la Sociedad de la Información y del Comercio Electrónico, le
                    informamos que el Sitio Web y el portal de Internet{" "}
                    <strong>www.lealchapaypintura.com</strong> (en adelante, el
                    "Web") es titularidad de Leal Chapa y Pintura SL, con domicilio
                    social en C/ Congreso, 57 P.I.S.A. con CIF nº B90330242. El
                    presente aviso legal regula las condiciones de uso del citado
                    portal de Internet.
                  </p>

                  <p>
                    <strong>Ley aplicable y jurisdicción</strong>
                  </p>
                  <p>
                    Con carácter general las relaciones entre Leal Chapa y Pintura SLU y
                    los usuarios de sus servicios telemáticos, presentes en la web,
                    se encuentran sometidas a la legislación y jurisdicción españolas.
                    Las partes renuncian expresamente al fuero que les pudiera
                    corresponder y someten expresamente a los Juzgados y Tribunales de
                    Mairena del Aljarafe para resolver cualquier controversia que pueda
                    surgir en la interpretación o ejecución de las presentes condiciones
                    contractuales.
                  </p>

                  <p>
                    <strong>Aceptación del usuario</strong>
                  </p>
                  <p>
                    Este Aviso Legal regula el acceso y utilización de la página web que
                    Leal Chapa y Pintura SLU pone a la disposición de los usuarios de
                    Internet. Se considera usuario la persona que acceda, navegue, utilice o
                    participe en los servicios y actividades de la página web. El usuario
                    queda informado, y acepta, que el acceso a la presente web no supone, en
                    modo alguno, el inicio de una relación comercial con Leal Chapa y
                    Pintura SLU. El acceso y navegación en el sitio web por parte del
                    usuario supone la aceptación de la totalidad de las presentes
                    Condiciones de Uso. En caso de desacuerdo con las condiciones debe
                    abstenerse a usar el sitio web.
                  </p>

                  <p>
                    <strong>Acceso a la web</strong>
                  </p>
                  <p>
                    El acceso a la página web por parte de los usuarios es de carácter libre
                    y gratuito. Algunos servicios pueden encontrarse sujetos a
                    contratación previa del servicio. En caso de ser necesario que el
                    usuario aporte datos personales para acceder a alguno de los servicios,
                    la recogida y el tratamiento de los datos se realizará de conformidad con
                    la normativa vigente, en concreto con el RGPD. Para más información,
                    consulte nuestra política de privacidad{" "}
                    <strong>www.lealchapaypintura.com</strong>.
                  </p>

                  <p>
                    <strong>Contenido y uso</strong>
                  </p>
                  <p>
                    La visita al sitio web por parte del usuario deberá hacerse de forma
                    responsable y de conformidad a la legalidad vigente, la buena fe, el
                    presente Aviso Legal y respetando los derechos de propiedad
                    intelectual e industrial de titularidad de Leal Chapa y Pintura SLU o
                    cualquier otras personas físicas o jurídicas. El uso de cualquiera de los
                    contenidos del sitio web con finalidades que sean o pudieran ser ilícitas
                    queda totalmente prohibido, así como la realización de cualquier acción
                    que cause o pueda causar daños o alteraciones de cualquier tipo no
                    consentidas por Leal Chapa y Pintura SLU, al sitio web o a sus contenidos.
                    El titular del web no se identifica con las opiniones vertidas en el mismo
                    por sus colaboradores. La empresa se reserva el derecho de efectuar sin
                    previo aviso las modificaciones que considere oportunas en su Web,
                    pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se
                    presten a través de la misma como la forma en la que éstos aparezcan
                    presentados o localizados en sus servidores.
                  </p>

                  <p>
                    <strong>Propiedad intelectual e industrial</strong>
                  </p>
                  <p>
                    Los derechos de propiedad intelectual del contenido de las páginas web,
                    su diseño gráfico y códigos son titularidad de Leal Chapa y Pintura SLU y,
                    por tanto, queda prohibida su reproducción, distribución, comunicación
                    pública, transformación o cualquier otra actividad que se realice con los
                    contenidos de la página web, ni siquiera, aunque se citen las fuentes, salvo
                    que se cuente con el consentimiento previo, expreso y por escrito de Leal
                    Chapa y Pintura SLU. Todos los nombres comerciales, marcas o signos
                    distintos de cualquier clase contenidos en las páginas web de la empresa son
                    propiedad de sus dueños y están protegidos por ley. Leal Chapa y Pintura SLU
                    no concede ninguna licencia o autorización de uso de ninguna clase sobre sus
                    derechos de propiedad intelectual e industrial o sobre cualquier otra
                    propiedad o derecho relacionado con el sitio web, y en ningún caso se
                    entenderá que el acceso y navegación de los usuarios implica una renuncia,
                    transmisión, licencia o cesión total ni parcial de dichos derechos por parte
                    de Leal Chapa y Pintura SLU. Cualquier uso de esos contenidos no autorizado
                    previamente por parte de Leal Chapa y Pintura SLU será considerado un
                    incumplimiento grave de los derechos de propiedad intelectual o industrial y
                    dará lugar a las responsabilidades legalmente establecidas. Leal Chapa y
                    Pintura SLU se reserva el derecho de ejercitar frente al usuario las acciones
                    judiciales y extrajudiciales que correspondan.
                  </p>

                  <p>
                    <strong>Responsabilidad y garantías</strong>
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU declara que ha adoptado las medidas necesarias que,
                    dentro de sus posibilidades y el estado de la tecnología, permitan el correcto
                    funcionamiento de su sitio web, así como la ausencia de virus y componentes
                    dañinos. Sin embargo, Leal Chapa y Pintura SLU no puede hacerse responsable de
                    las siguientes situaciones que se enumeran a título enunciativo, pero no
                    limitativo:
                  </p>
                  <ul>
                    <li>La continuidad y disponibilidad de los Contenidos.</li>
                    <li>
                      La ausencia de errores en dichos Contenidos ni la corrección de cualquier
                      defecto que pudiera ocurrir.
                    </li>
                    <li>La ausencia de virus y/o demás componentes dañinos.</li>
                    <li>
                      Los daños o perjuicios que cause cualquier persona que vulnere los sistemas
                      de seguridad de Leal Chapa y Pintura SLU.
                    </li>
                    <li>
                      El uso que los usuarios puedan hacer de los contenidos incluidos en el web.
                      En consecuencia, Leal Chapa y Pintura SLU no garantiza que el uso que los
                      usuarios puedan hacer de los contenidos que en su caso se incluyan en el
                      sitio web, se ajusten al presente aviso legal, ni que el uso del sitio web se
                      realice de forma diligente.
                    </li>
                    <li>
                      El uso por menores de edad del sitio web o del envío de sus datos personales
                      sin el permiso de sus tutores, siendo los tutores responsables del uso que
                      hagan de Internet.
                    </li>
                    <li>
                      Los contenidos a los que el usuario pueda acceder a través de enlaces no
                      autorizados o introducidos por usuarios mediante comentarios o herramientas
                      similares.
                    </li>
                    <li>
                      La introducción de datos erróneos por parte del usuario o de un tercero.
                    </li>
                  </ul>
                  <p>
                    Leal Chapa y Pintura SLU podrá suspender temporalmente y sin previo aviso,
                    la accesibilidad al sitio web con motivo de operaciones de mantenimiento,
                    reparación, actualización o mejora. No obstante, siempre que las circunstancias lo
                    permitan, Leal Chapa y Pintura SLU comunicará al usuario, con antelación
                    suficiente, la fecha prevista para la suspensión de los contenidos. Asimismo,
                    de conformidad con los arts. 11 y 16 de la Ley 34/2002, de 11 de julio, de
                    servicios de la sociedad de la información y de comercio electrónico (LSSICE),
                    Leal Chapa y Pintura SLU se compromete a la eliminación o, en su caso, bloqueo de
                    los contenidos que pudieran afectar o ser contrarios a la legislación vigente,
                    los derechos de terceros o la moral y orden público.
                  </p>

                  <p>
                    <strong>Cookies</strong>
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU utiliza cookies, a los efectos de optimizar y
                    personalizar su navegación por el sitio web. Las cookies son ficheros físicos
                    de información que se alojan en el propio terminal del usuario, la información
                    recogida mediante las cookies sirve para facilitar la navegación del usuario
                    por el portal y optimizar la experiencia de navegación. Los datos
                    recopilados mediante las cookies pueden ser compartidos con los creadores de
                    las mismas, pero en ningún caso la información obtenida por las mismas será
                    asociada a datos personales ni a datos que puedan identificar al usuario.
                    Sin embargo, si el usuario no desea que se instalen cookies en su disco duro,
                    tiene la posibilidad de configurar el navegador de tal modo que impida la
                    instalación de estos archivos. Para obtener más información consulte nuestra
                    Política de Cookies{" "}
                    <strong>
                      www.lealchapaypintura.com/cookies
                    </strong>
                    .
                  </p>

                  <p>
                    <strong>Enlaces (links)</strong>
                  </p>
                  <p>
                    La presencia de enlaces (links) en la página web de Leal Chapa y Pintura SLU
                    hacia otros sitios de Internet tiene finalidad meramente informativa y en
                    ningún caso suponen sugerencia, invitación o recomendación sobre los mismos.
                    Leal Chapa y Pintura SLU no asumirá responsabilidad por los contenidos de un
                    enlace perteneciente a un sitio web ajeno, ni garantizará la fiabilidad,
                    exactitud, amplitud, veracidad, validez y disponibilidad técnica. En el caso
                    de que en otros sitios web se establezcan enlaces a la página web de Leal Chapa
                    y Pintura SLU, no se entenderá que Leal Chapa y Pintura SLU ha autorizado el
                    enlace o el contenido del sitio web en el que se contiene el enlace, tampoco
                    podrá incluirse en la página del enlace contenidos inapropiados, difamatorios,
                    ilegales, obscenos o ilícitos, ni otros contenidos que sean contrarios a la
                    legalidad vigente. Leal Chapa y Pintura SLU se reserva la posibilidad de contactar
                    con el propietario del sitio web en el que se establezca el enlace si considera
                    que se incumple la normativa, así como de ejercitar las correspondientes acciones
                    judiciales y extrajudiciales.
                  </p>

                  <p>
                    <strong>Modificación de las condiciones</strong>
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU se reserva expresamente el derecho a modificar
                    unilateralmente, total o parcialmente, sin necesidad de previo aviso, el
                    presente Aviso Legal. El usuario reconoce y acepta que es su responsabilidad
                    revisar periódicamente el presente Aviso Legal.
                  </p>
                </div>
              </div>
              <div className="btn-wrap mt-40">
                <Link to="/" className="btn style2">
                  Volver <i className="fas fa-arrow-left ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
